export default __webpack_public_path__ + "static/media/flash14.8417ff73.png";